import { ACTIONS } from '../actions/actionTypes';

const INITIAL_STATE = {
    status: 'Stopped',
    time: 0
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case ACTIONS.START_TIMER:
        return { ...state, status: 'Running' };
    case ACTIONS.STOP_TIMER:
        return { ...state, status: 'Stopped' };
    case ACTIONS.TICK_TIMER:
        return { ...state, time: state.time + 1 };
    case ACTIONS.RESET_TIMER:
        return { ...state, time: 0 };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/timeReducer.js